import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { PageLoader } from './Loading'
import AwaitingApproval from '../../pages/workers/AwaitingApproval'

const WorkersRoute = ({ children }) => {
  const { isAuthenticated, loading, userProfile, userStatus, hasPortalAccess } = useAuth()
  const location = useLocation()

  if (loading) {
    return <PageLoader message="Checking authentication..." />
  }

  if (!isAuthenticated) {
    const next = encodeURIComponent(location.pathname + location.search)
    return <Navigate to={`/workers/login?next=${next}`} replace />
  }

  if (hasPortalAccess) {
    return children
  }

  const variant =
    userProfile?.isActive === false || userStatus === 'rejected'
      ? 'inactive'
      : 'pending'

  return <AwaitingApproval variant={variant} />
}

export default WorkersRoute
